import { NgModule, inject } from '@angular/core';
import { Routes, RouterModule, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { EditorModule } from 'primeng/editor';

import { UserManagementComponent } from './base/user-management/user-management.component';
import { LoginComponent } from './base/login/login.component';
import { ChangePasswordComponent } from './base/change-password/change-password.component';

import { HomeComponent } from './domain/home/home.component';
import { AuthGuard } from './base/guards/auth.guard';
import * as pages from './core/routing/page-names';
import { EditProfileComponent } from './base/edit-profile/edit-profile.component';
import { SetPasswordComponent } from './base/set-password/set-password.component';
import { ForgotPasswordComponent } from './base/forgot-password/forgot-password.component';
import { ClientService } from './base/services/client/client.service';
import { AdminOrClientAdminGuard } from './base/guards/admin-client-admin.guard';
import { ClientAdministrationComponent } from './domain/administration/client-administration/client-administration.component';
import { AdminGuard } from './base/guards/admin.guard';
import { CategoryComponent } from './domain/master-data/category/category.component';
import { SubscriptionComponent } from './domain/master-data/subscription/subscription.component';
import { PrivacyPolicyComponent } from './domain/master-data/privacy-policy/privacy-policy.component';
import { OrderComponent } from './domain/transaction/order/order.component';
import { SalesOverviewComponent } from './domain/transaction/sales-overview/sales-overview.component';
import { PublicPrivacyPolicyComponent } from './domain/master-data/privacy-policy/public-privacy-policy/public-privacy-policy.component';
import { DeleteAccountComponent } from './domain/delete-account/delete-account.component';
import { DeliveryDetailsComponent } from './domain/transaction/order/delivery-details/delivery-details.component';
import { ProductTemplateComponent } from './domain/master-data/product-template/product-template.component';
import { PublishingWizardComponent } from './domain/master-data/product-template/publishing-wizard/publishing-wizard.component';
import { InvoiceComponent } from './domain/transaction/invoice/invoice.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: pages.homePageName
  },
  {
    path: pages.homePageName,
    component: HomeComponent,
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state)]
  },
  {
    path: pages.userManagementPageName,
    component: UserManagementComponent,
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AdminOrClientAdminGuard).canActivate(route, state)],
    resolve: {
      data: () => { return inject(ClientService).getAccessibleClients(); }
    }
  },
  {
    path: pages.clientAdministrationPageName,
    component: ClientAdministrationComponent,
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AdminOrClientAdminGuard).canActivate(route, state)
    ],
  },

  {
    path: pages.loginPageName,
    component: LoginComponent
  },
  {
    path: pages.changePasswordPageName,
    component: ChangePasswordComponent,
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state)]
  },
  {
    path: pages.editProfilePageName,
    component: EditProfileComponent,
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state)]
  },
  {
    path: pages.setPasswordPageName,
    component: SetPasswordComponent
  },
  {
    path: pages.forgotPasswordPageName,
    component: ForgotPasswordComponent
  },
  {
    path: pages.categoryPageName,
    component: CategoryComponent,
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state)]

  },
  {
    path: pages.subscriptionPageName,
    component: SubscriptionComponent,
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state)]
  },
  {
    path: pages.privacypolicyPageName,
    component: PrivacyPolicyComponent,
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state)]

  },
  {
    path: pages.orderPageName,
    component: OrderComponent,
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state)]
  },
  {
    path: pages.salesOverviewPageName,
    component: SalesOverviewComponent,
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AdminOrClientAdminGuard).canActivate(route, state)]
  },
  {
    path: pages.deliverydetailsPageName,
    component: DeliveryDetailsComponent,
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state)]

  },
  {
    path: pages.productTemplatePageName,
    component: ProductTemplateComponent,
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state)]
  },
  {
    path: pages.productTemplatePageName + '/publish',
    component: PublishingWizardComponent,
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state)]
  },

  {
    path: pages.publicPrivacyPolicyPageName,
    component: PublicPrivacyPolicyComponent
  },
  {
    path: pages.deleteAccountPageName,
    component: DeleteAccountComponent
  },
  {
    path: pages.invoicePageName,
    component: InvoiceComponent,
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AdminGuard).canActivate(route, state)]
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {}),
    EditorModule

  ],
  providers: [

  ],

  exports: [RouterModule]
})
export class AppRoutingModule { }
